// Homepage "In Stock" section (replaced The Lab teaser). Live feed of
// products with any variant qty > 0; fallback links to Drops + The Lab.
import { Link } from 'react-router-dom';
import Reveal from '../components/loadout/Reveal';
import { useInStock, InStockCard } from '../components/storefront/InStock';
import LabTeaser from './LabTeaser';

const HOME_LIMIT = 8;

export default function InStockTeaser() {
        const { loading, count, products } = useInStock(HOME_LIMIT);
        // Nothing on the shelf → The Lab teaser takes this slot instead.
        if (!loading && products.length === 0) return <LabTeaser />;
        return (
                <section data-testid="home-in-stock-section" className="bg-[#0A0A0A] text-white py-16 md:py-24">
                        <div className="mx-auto max-w-[1440px] px-6">
                                <Reveal>
                                        <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">05 / IN STOCK</div>
                                </Reveal>
                                <Reveal delay={60}>
                                        <h2 className="mt-4 font-display text-white text-[32px] md:text-[48px] leading-[0.95] max-w-[820px]">On the shelf. Ships now.</h2>
                                </Reveal>
                                <Reveal delay={120}>
                                        <p className="mt-4 font-sans text-[16px] text-[#8A8A8A] max-w-[620px] leading-relaxed">Gear sitting in our Noida warehouse, ready to dispatch. Updates live as stock moves.</p>
                                </Reveal>
                                <div className="mt-12">
                                        {loading ? (
                                                <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-white/40">Loading…</p>
                                        ) : (
                                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                                                        {products.map((p, i) => (
                                                                <Reveal key={p.handle} delay={40 * i}><InStockCard p={p} /></Reveal>
                                                        ))}
                                                </div>
                                        )}
                                </div>
                                {count > 0 && (
                                        <div className="mt-12">
                                                <Link to="/in-stock" data-testid="home-in-stock-cta" className="inline-block font-mono text-[12px] tracking-[0.18em] uppercase border border-white/30 px-6 py-4 hover:border-[#FF9F1C] hover:text-[#FF9F1C] transition-colors">
                                                        View all {count} in stock →
                                                </Link>
                                        </div>
                                )}
                        </div>
                </section>
        );
}
